import { useMemo } from 'react';

import { Tabs, Tab } from 'libs/ui';
import { zones } from 'services/zones';

const zoneType = 'single';

export const ZonesTabs = (props) => {
  const { activeZone, setZone } = props;

  const items = useMemo(() => zones.getZones(), []);

  const getTabsEl = () => {
    return items.map((zone) => {
      const isSelected = zone.id === activeZone;
      return (
        <Tab isSelected={isSelected} key={zone.id} color={zone.color} type={zoneType} onClick={() => setZone(zone.id)}>
          <div>{zone.name}</div>
        </Tab>
      );
    });
  };

  const tabsEl = getTabsEl();

  return <Tabs>{tabsEl}</Tabs>;
};
